import type {ReactElement, ReactNode} from 'react';

export enum MediaHoverPreviewMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
}

export interface PreviewContentSize {
  width: number;
  height: number;
}

export interface MediaHoverPreviewProps {
  previewSrc: string;
  children: ReactNode;
  mediaType?: MediaHoverPreviewMediaType;
  isEnabled?: boolean;
  className?: string;
  /**
   * Renders custom preview content instead of the default <img>/<video> built from previewSrc.
   */
  getPreviewContent?: (contentSize: PreviewContentSize) => ReactElement;
  /**
   * Measure the wrapper box instead of the inner img/video. Needed when the inner media is
   * deliberately scaled beyond its visible window (e.g. a cropped video preview).
   */
  shouldMeasureWrapper?: boolean;
  /**
   * How many times bigger than the hovered media the preview renders. Defaults to MEDIA_HOVER_PREVIEW_SCALE.
   */
  scale?: number;
}

export interface PreviewPlacement {
  top: number;
  left: number;
  width: number;
  height: number;
}

export const MEDIA_HOVER_PREVIEW_SCALE = 2.5;
/** Must match the padding in media-hover-preview.module.scss (var.spacing(2)). */
export const MEDIA_HOVER_PREVIEW_CARD_PADDING = 8;
export const MEDIA_HOVER_PREVIEW_OPEN_DELAY_MS = 300;
export const MEDIA_HOVER_PREVIEW_VIEWPORT_MARGIN = 16;
export const MEDIA_HOVER_PREVIEW_ANCHOR_GAP = 12;
export const MEDIA_HOVER_PREVIEW_MAX_VIEWPORT_FRACTION = 0.85;
